import React from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Download } from "lucide-react";
import TypewriterEffect from "./TypewriterEffect";
import ZohoFormWrapper from "./ZohoFormWrapper";

const Hero = () => {
  const threatResponses = ["Threat Detection", "Threat Investigation", "Threat Response"];

  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div className="space-y-6">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold tracking-tight animate-fade-in leading-tight">
              Spharaka: The Autonomous Cyber Defence Platform Powered by{" "}
              <span className="text-[#8932c8]">Agentic AI</span>
            </h1>
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold tracking-tight animate-fade-in leading-tight mt-3">
              Autonomous{" "}
              <TypewriterEffect phrases={threatResponses} />
            </h2>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 max-w-lg animate-fade-in leading-relaxed mt-4">
              An AI-Native, Unified Security Intelligence Platform that learns, decides, and defends autonomously across your entire digital ecosystem, powered by AuraXP™, your organization's intelligent cyber brain.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <a 
                href="/datasheet.html" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block"
              >
                <Button size="cta" className="bg-[#8932c8] hover:bg-[#7a2cb3] text-white w-full sm:w-auto flex items-center justify-center gap-2">
                  <Download className="h-5 w-5" />
                  Download Datasheet
                </Button>
              </a>
              <Dialog>
                <DialogTrigger asChild>
                  <Button size="cta" variant="outline" className="border-[#8932c8] text-[#8932c8] hover:bg-[#8932c8]/5 w-full sm:w-auto flex items-center justify-center">
                    Request Demo
                  </Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-md">
                  <DialogHeader>
                    <DialogTitle>Request a Demo</DialogTitle>
                  </DialogHeader>
                  <ZohoFormWrapper title="" buttonText="Request Demo" />
                </DialogContent>
              </Dialog>
            </div>
            <p className="text-xs sm:text-sm text-gray-500 italic mt-4">
              Bringing the power of AI to Cybersecurity in manner never imagined
            </p>
          </div>
          <div className="md:ml-auto lg:mr-0 hero-image-container">
            <img 
              src="/lovable-uploads/2ed320a6-d7dd-4a96-a88d-796b60d9d77b.png" 
              alt="Spharaka XDR Autonomous security platform with AuraXP"
              className="w-full h-auto dashboard-image"
              loading="eager"
              decoding="async"
              width="800"
              height="600"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
